import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { AppConstants, LabelConstants } from 'src/app/utilities/app-constants';
import { Auth } from 'aws-amplify';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { FolioHelperService } from 'src/app/utilities/folio-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {
  readonly MY_CONSTANT = LabelConstants;

  constructor(
    private router: Router,
    private folioHelperService: FolioHelperService,
    private matSnackBar: MatSnackBar) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let isLoggedIn = true;
    this.folioHelperService.fetchUserName();

    const userAttributes = this.folioHelperService.fetchDataFromLocalStorage('__login_info__');
    if (userAttributes.backendType && userAttributes.backendType === AppConstants.BACKEND_TYPE_BATON) {
      Auth.currentAuthenticatedUser().then((s) => {
        isLoggedIn = true;
      }).catch((e) => {
        console.log('Authenticated user ERROR: ', e);
        isLoggedIn = false;
        this.matSnackBar.open('Session timed out or Authentication error, please login again', null, {
          duration: 1000
        });
        setTimeout(() => {
          window.location.href = environment.urlRedirectToBaton;
        }, 1000);
      });
    } else {
      isLoggedIn = true;
    }


    if (!isLoggedIn) {
      this.router.navigate(['/login']);
    }
    return isLoggedIn;
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.canActivate(route, state);
  }

}

